export interface PartialTheme {
	id?: number | undefined;
	name: string; // the custom/display name for the item
	title: string; // unique internal name for the item
	stylepack: string; // corresponds to template.stylePack
	colors: string[];
	version: number;
}

export interface Theme extends PartialTheme {
	id: number;
}

export interface ColorMapping {
	templateKey: string,
	fieldToColorIndex: Record<string, number> // key is field's dataKey, value is index of color in theme
	fieldToOpacity: Record<string, number>
}

export interface ThemeMaps {
	[key: string]: ColorMapping;
}

export enum THEME_FILTER {
	SUGGESTED = 1,
	CUSTOM = 2
}

export interface ThemesState {
	defaultThemes: Theme[],
	customThemes: Theme[],
	viewedTheme: Theme | null,
	// theme editing is false when "editing"/changing a default
	// theme before it is named (see SET_EDITING_THEME)
	themeEditing: boolean,
	attachedThemes: Record<string, number>,
	themeFilter: THEME_FILTER,
	themeMaps: ThemeMaps | null
}